import { FC, useRef } from 'react'
import { InputSwitch } from 'primereact/inputswitch'
import { Toast } from 'primereact/toast'
import { Spinner } from '../../components'
import {
  useGetAlternateExportQuery,
  useToggleAlternateExportMutation,
} from '../../generated/graphql'
import { showToast } from '../../helpers/showSuccessToast'

const ExportSettings: FC = () => {
  const toastSuccess = useRef(null)
  const toastError = useRef(null)
  const { loading, data } = useGetAlternateExportQuery()
  const [toggleAlternateExport] = useToggleAlternateExportMutation()

  const handleToggle = async () => {
    try {
      const { data } = await toggleAlternateExport({
        refetchQueries: ['getAlternateExport'],
      })
      if (data?.toggleAlternateExport !== undefined) {
        showToast(
          toastSuccess,
          data.toggleAlternateExport
            ? 'Alternate export enabled'
            : 'Alternate export disabled',
        )
      }
    } catch (error) {
      showToast(toastError, 'Server Error', 'error')
      console.log(error)
    }
  }

  if (loading) return <Spinner />

  return (
    <>
      <Toast ref={toastSuccess} />
      <Toast ref={toastError} />
      <div style={{ padding: '1.3rem 3rem 3rem 3rem', color: '#f4f4fc' }}>
        <div style={{ marginBottom: '2rem' }}>
          <h1 style={{ fontWeight: 100, fontSize: '1.8rem', color: '#f4f4fc' }}>Export Settings</h1>
        </div>
        <div style={{
          background: 'rgba(45, 45, 51, 0.45)',
          backdropFilter: 'blur(40px)',
          border: '1px solid rgba(134, 134, 134, 0.4)',
          borderRadius: '8px',
          padding: '2rem',
          display: 'inline-flex',
          flexDirection: 'column',
          gap: '1rem',
          minWidth: '320px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label htmlFor="alternateExport" style={{ color: '#f4f4fc', fontSize: '1rem' }}>
              Send every other sale
            </label>
            <InputSwitch
              id="alternateExport"
              checked={data?.getAlternateExport ?? true}
              onChange={handleToggle}
            />
          </div>
          <small style={{ color: '#a0a0a0' }}>
            When enabled, only every other sale is sent to the external API. When disabled, all sales are sent.
          </small>
        </div>
      </div>
    </>
  )
}

export { ExportSettings }
